import { render, staticRenderFns } from "./UsersJoined.vue?vue&type=template&id=518dbb67&scoped=true&"
import script from "./UsersJoined.vue?vue&type=script&lang=js&"
export * from "./UsersJoined.vue?vue&type=script&lang=js&"
import style0 from "./UsersJoined.vue?vue&type=style&index=0&id=518dbb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518dbb67",
  null
  
)

export default component.exports